export default "__VITE_ASSET__b92bf3f8__"